import { createLucideIcon } from "lucide-react";

export const CopyYamlIcon = createLucideIcon("copy-yaml", [
  [
    "path",
    {
      d: "m15 19 .048-4.558",
      key: "y9xcxy",
    },
  ],
  [
    "path",
    {
      d: "M17.5 11 15 14.5 12.5 11",
      key: "1xpesf",
    },
  ],
  [
    "path",
    {
      d: "M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2",
      key: "1qd6ae",
    },
  ],
  [
    "rect",
    {
      x: "8",
      y: "8",
      width: "14",
      height: "14",
      rx: "2",
      key: "1an92s",
    },
  ],
]);
